import {
  CreateGfFlyerItemFigmaJobDto,
  GfFlyerItemList,
  GfFigmaTemplateData,
} from "@swagger/typescript-fetch-goflyer";
import { adminApiService } from "../../../utils/api";
import { toastError } from "../../../utils/pageUtil/toast";

export const generateFlyerItemsFlyersFn = async (
  flyerItemList: GfFlyerItemList,
  totalFlyerItemCount: number,
  figmaTemplateData?: GfFigmaTemplateData,
  authHeaders?: {
    headers: {
      Authorization: string;
    };
  }
) => {
  try {
    const createJobDto: CreateGfFlyerItemFigmaJobDto = {
      flyerItemList: flyerItemList,
      totalFlyerItemCount: totalFlyerItemCount,
      status: CreateGfFlyerItemFigmaJobDto.StatusEnum.Waiting,
      ...(figmaTemplateData ? { figmaTemplateData } : {}),
    };

    const newJob =
      await adminApiService.createOneBaseGfFlyerItemFigmaJobAdminControllerGfFlyerItemFigmaJob(
        createJobDto,
        authHeaders
      );

    return newJob;
  } catch (error) {
    toastError("Error generating flyer items:");
    console.error("Error generating flyer items:", error);
    throw new Error("Failed to generate flyer items");
  }
};

export const downloadGeneratedFlyers = async (flyerItemListId: string) => {
  const flyerItemFigmaJobResponse =
    await adminApiService.getManyBaseGfFlyerItemFigmaJobAdminControllerGfFlyerItemFigmaJob(
      undefined,
      undefined,
      [`flyerItemList.id||eq||${flyerItemListId}`, `status||eq||completed`],
      undefined,
      ["updatedAt,DESC"],
      undefined,
      1
    );

  const completedJobs = flyerItemFigmaJobResponse?.data;
  if (!completedJobs || completedJobs.length === 0) {
    toastError(
      "No Flyer Images found for the latest this FlyerItem Please Generate One then Download it."
    );
    return;
  }

  const latestJob = completedJobs[0];

  const { generatedFlyerImages } = latestJob;
  if (generatedFlyerImages && generatedFlyerImages.length > 0) {
    for (const imageEntry of generatedFlyerImages) {
      const imageUrl = imageEntry?.gfImage?.src;
      if (!imageUrl) {
        console.warn(
          `No source URL for image entry with index ${imageEntry.index}.`
        );
        continue;
      }

      const response = await fetch(imageUrl);
      if (!response.ok) {
        toastError(`Failed to download image: ${imageUrl}`);
        continue;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `flyer-item-${imageEntry.index}.png`;
      anchor.click();
      URL.revokeObjectURL(url);
    }
  } else {
    toastError(
      "No Flyer Images found for the latest this FlyerItem Please Generate One then Download it."
    );
  }
};
